module.exports = __webpack_public_path__ + "img/image-4.4590e79c.png";